import clsx from "clsx";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "moment/locale/he";
import { BaseDialog } from '../../../components/DialogTemplates/BaseDialog';
import { RenderHtmlTemplate } from '../../../helpers/Utils/HtmlUtils';

const TemplatePreview = ({
  classes,
  isOpen = false,
  templateDetails = {},
  onClose = () => null,
  isMyTemplate = false
}: any) => {
  const { t } = useTranslation();
  const { isDarkMode } = useSelector((state: any) => state.core);

  return <BaseDialog
    classes={classes}
    customContainerStyle={classes.beeTemplate}
    contentStyle={classes.beeTemplate}
    open={isOpen}
    showDivider={true}
    onConfirm={() => {
      onClose(templateDetails);
    }}
    onClose={onClose}
    onCancel={onClose}
    reduceTitle
    showDefaultButtons={true}
    title={t('common.Preview')}
    confirmText={t('common.loadTemplate')}
  >
    {/* Dark mode only: pins a light surface because this renders the customer's own
        template HTML directly (no iframe/shadow-DOM isolation), so it must show what
        recipients see. Light mode keeps master's inherited styling untouched. */}
    <Box className={clsx(classes.templateModal)} style={{ direction: 'ltr', ...(isDarkMode ? { backgroundColor: '#fff', color: 'rgba(0,0,0,0.87)', colorScheme: 'light' } : {}) }}>
      {isMyTemplate
        ? RenderHtmlTemplate(templateDetails.Html)
        : (
          <img src={decodeURIComponent(templateDetails?.ThumbnailUrl)}
            style={{
              width: '100%',
              height: 'auto',
              overflowY: 'auto'
            }}
            alt={templateDetails.Name}
            title={templateDetails.Name}
          />
        )
      }
    </Box>
  </BaseDialog>
}

export default TemplatePreview;
